/**
 * Utility-Funktionen für Performance-Optimierung
 */

// Kritische Ressourcen preloaden
export const preloadCriticalResources = () => {
  // Hero-Bild preloaden (für LCP-Optimierung)
  const heroImageLink = document.createElement('link');
  heroImageLink.rel = 'preload';
  heroImageLink.as = 'image';
  heroImageLink.href = '/assets/images/bg.webp';
  heroImageLink.type = 'image/webp';
  document.head.appendChild(heroImageLink);

  // Logo preloaden
  const logoLink = document.createElement('link');
  logoLink.rel = 'preload';
  logoLink.as = 'image';
  logoLink.href = '/assets/images/logo.webp';
  logoLink.type = 'image/webp';
  document.head.appendChild(logoLink);

  // Wichtige Fonts preloaden (falls vorhanden)
  const fontLink = document.createElement('link');
  fontLink.rel = 'preconnect';
  fontLink.href = 'https://fonts.googleapis.com';
  document.head.appendChild(fontLink);

  const fontLink2 = document.createElement('link');
  fontLink2.rel = 'preconnect';
  fontLink2.href = 'https://fonts.gstatic.com';
  fontLink2.crossOrigin = 'anonymous';
  document.head.appendChild(fontLink2);
};

// Resource Hints für externe Services
export const addResourceHints = () => {
  // Chatwoot preconnect
  const chatwootLink = document.createElement('link');
  chatwootLink.rel = 'preconnect';
  chatwootLink.href = 'https://widget.chatwoot.com';
  document.head.appendChild(chatwootLink);

  // Font Awesome preconnect
  const fontAwesomeLink = document.createElement('link');
  fontAwesomeLink.rel = 'preconnect';
  fontAwesomeLink.href = 'https://cdnjs.cloudflare.com';
  document.head.appendChild(fontAwesomeLink);
};

// Lazy Loading für nicht-kritische Ressourcen
export const setupLazyLoading = () => {
  // Intersection Observer für lazy loading
  if ('IntersectionObserver' in window) {
    const lazyImageObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const lazyImage = entry.target as HTMLImageElement;
          const src = lazyImage.dataset.src;
          if (src) {
            lazyImage.src = src;
            lazyImage.classList.remove('lazy');
            lazyImageObserver.unobserve(lazyImage);
          }
        }
      });
    });

    // Alle lazy Images observieren
    document.querySelectorAll('img[data-src]').forEach((img) => {
      lazyImageObserver.observe(img);
    });
  }
};

// Bundle-Größe analysieren (nur für Development)
export const analyzeBundleSize = () => {
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    console.log('Bundle Analysis - Performance Timings:');
    if (performance.getEntriesByType) {
      const navigationEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
      if (navigationEntries.length > 0) {
        const timing = navigationEntries[0];
        console.log({
          'DNS Lookup': timing.domainLookupEnd - timing.domainLookupStart,
          'TCP Connection': timing.connectEnd - timing.connectStart,
          'Request': timing.responseStart - timing.requestStart,
          'Response': timing.responseEnd - timing.responseStart,
          'DOM Processing': timing.domInteractive - timing.responseEnd,
          'Load Complete': timing.loadEventEnd - timing.fetchStart
        });
      }
    }
  }
};

// Service Worker für Caching (falls implementiert)
export const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator && import.meta.env.PROD) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      console.log('Service Worker registriert:', registration);
    } catch (error) {
      console.log('Service Worker Registrierung fehlgeschlagen:', error);
    }
  }
};

// Critical CSS inlining (würde im Build-Prozess passieren)
export const inlineCriticalCSS = () => {
  // Diese Funktion würde im Build-Prozess verwendet werden
  // um kritisches CSS inline zu setzen für bessere LCP-Zeiten
  const criticalCSS = `
    /* Hero Section - kritisch für LCP */
    .hero {
      background-image: url('/assets/images/bg.webp');
      background-size: cover;
      background-position: center;
      min-height: 100vh;
    }
    
    /* Header - kritisch für First Paint */
    .header {
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 1000;
    }
  `;
  
  // In einem echten Build-System würde das automatisch passieren
  console.log('Critical CSS würde hier inline gesetzt werden:', criticalCSS);
};
